import styled from '@emotion/styled'
import {formatName} from '../../../../services/util/formatter'
import AvatarBase from '../../../1elements/Avatar/AvatarBase'
import {Text} from '../../../1elements'
import OnlineBadge from '../../../1elements/Avatar/OnlineBadge'

const AccountAvatar = ({accountName, className, avatar, online}) => {
    const formattedAccountName = accountName && formatName(avatar ? accountName.fullName : accountName)
    return (
        <OnlineBadge online={online}>
            <AvatarBase className={className} >
                {
                    avatar
                        ? <AvatarImage src={avatar} alt={formattedAccountName} />
                        : <Text type={'accountAvatar'}>{formattedAccountName}</Text>
                }
            </AvatarBase>
        </OnlineBadge>
    )
}

export default AccountAvatar

const AvatarImage = styled.img({
    objectFit: 'cover',
    maxWidth: 100,
    height: 'auto',
})